<template>
    <div class="rr-landing">
        <div class="rr-container">
            <LandingHero></LandingHero>
            <WhyRoori></WhyRoori>
            <PriceList></PriceList>
        </div>
    </div>
</template>
<script setup>
import WhyRoori from "../components/view-components/WhyRoori.vue";
import PriceList from "../components/view-components/PriceList.vue";
import LandingHero from "../components/view-components/LandingHero.vue";

</script>
<style scoped>
.rr-landing {
    width: 100%;

}
</style>
